import React, { useContext } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useTranslation } from "react-i18next";
import i18n from '../i18n';
import LocaleContext from '../LocaleContext';
import GetIcon from './GetIcon';
import HeadingBuilder from './HeadingBuilder';
import * as Constants from '../constants';

// Add a language here (once its translation file exists) and it appears in
// every LanguagePicker automatically. 'short' shows on the compact toggle;
// 'label' is the language's own name (endonym), shown in the menu.
//
// Both are rendered inside 'translate="no"' spans, because they are
// identity rather than prose and machine translation wrecks them. Google
// Translate read the bare 'Es' as the Spanish word 'es' and rendered the
// toggle as 'Is' (seen 260817); it would likewise turn 'Español' into
// 'Spanish', which defeats the point of naming each language in itself.
// The span matters as much as the attribute: Translate swaps text nodes
// for '<font>' wrappers, and one sitting where React expects a text node
// leaves the toggle stuck on a stale value until a page reload.
const LANGUAGES = [
    { code: 'en', short: 'En', label: 'English' },
    { code: 'es', short: 'Es', label: 'Español' },
    { code: 'ht', short: 'Ht', label: 'Kreyòl ayisyen' },
];

// Compact language dropdown. A globe (the language-neutral convention) plus
// the current language's short code on the toggle, so the navbar stays narrow
// no matter how many languages LANGUAGES holds. Pass a `className` (e.g.
// 'ms-3') to add spacing after whatever precedes it.
const LanguagePicker = ({ className = '' }) => {
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    function changeLocale (l) {
      if (locale !== l) {
        i18n.changeLanguage(l);
      }
    }

    const current =
      LANGUAGES.find(({ code }) => code === locale) || LANGUAGES[0];

    return (
      // 'flex-column' stacks the help icon below the dropdown (instead of
      // beside it) even though this sits inside the navbar's flex-row.
     <div
        className={
          `d-inline-flex flex-column align-items-center ${className}`
        }
     >
      <Dropdown align="end" className="d-inline-block align-middle">
        <Dropdown.Toggle
          variant="outline-secondary"
          size="sm"
          id="language-picker"
          aria-label={t('global.label.language')}
        >
          <GetIcon toGet={Constants.GET_ICON_GLOBE} />{' '}
          <span translate="no">{current.short}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {LANGUAGES.map(({ code, label }) => (
            <Dropdown.Item
              key={code}
              active={code === locale}
              onClick={() => changeLocale(code)}
            >
              <span translate="no">{label}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <HeadingBuilder
        headingText    = {Constants.DOT}

        tippyAlertText = {t('languagePicker.tippyContent')}
        tippyText      = {Constants.DOT}
      />
     </div>
    );
};

export default LanguagePicker;
